import * as React from 'react';
import { SvgProps, Svg, G, Path, Circle } from 'react-native-svg';
function SvgDragAndDrop(props: SvgProps) {
  return (
    <Svg height={24} viewBox="0 0 26 44" width={24} {...props}>
      <G transform="translate(.21)" fill={props.color} fillRule="nonzero">
        <Circle cx={3.73} cy={3.73} r={3.73} />
        <Circle cx={21.85} cy={3.73} r={3.73} />
        <Circle cx={3.73} cy={21.76} r={3.73} />
        <Circle cx={21.85} cy={21.76} r={3.73} />
        <Circle cx={3.73} cy={39.79} r={3.73} />
        <Circle cx={21.85} cy={39.79} r={3.73} />
      </G>
    </Svg>
  );
}
export default SvgDragAndDrop;